module.exports = __webpack_public_path__ + "img/Insights.6eaddfad.webp";